import BillsDiscovery from '../../../bills/components/BillsDiscovery';

export default function BillsDiscoveryScreen() {
    return <BillsDiscovery />;
}
